import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'GetActiveGames',
        args: {},
    });

    const response = {
        games: [],
        error: null,
    };

    if (result?.response?.code > 299) {
        response.error = response.message;
    } else {
        response.games = result;
    }

    return response;
};
